import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";

/** Role  */
const roles = {
  autoComplete: "autoComplete",
  input: "autoComplete-input",
  label: "autoComplete-label",
};

/**
 * AutoComplete input
 * @deprecated
 * @param {Object} props
 * @param {String} props.id Input unique id Required
 * @param {Any} props.value value
 * @param {Function} props.onChange onChange function to get return value
 * @param {String} props.optionValueKey option value key (default : 'value')
 * @param {String} props.optionLabelKey option value key (default : 'label')
 * @param {Array} props.options Options ( array[{label,value},{label,value},...])
 * @param {Boolean} props.error Apply different style if error is true
 * @param {Boolean} props.multiple if multiple select
 * @param {Object} props.style Input additionnal style Optionnal
 * @param {Function} props.icon Input icon
 * @param {Function} props.renderTags Input Chip
 * @param {Number} props.limitTags number of Chip to see
 */
export const SelectAutoComplete = ({
  id,
  value,
  onChange,
  optionValueKey = "value",
  optionLabelKey = "label",
  options,
  error,
  multiple,
  style,
  icon,
  renderTags,
  renderOption,
  limitTags,
  isOptionEqualToValue,
  getOptionLabel,
  filterOptions,
  disabled,
  disableClearable,
  ...props
}) => {
  /** init  */
  const [errorAutoComplete, setErrorAutoComplete] = useState(false);
  const [defaultValue, setDefaultValue] = useState(multiple ? [] : null);

  useEffect(() => {
    if (Array.isArray(value) && Array.isArray(options)) {
      setDefaultValue(
        options.filter((o) => value.find((v) => o[optionValueKey] === v[optionValueKey] || o[optionValueKey] === v))
      );
    } else if (value && Array.isArray(options)) {
      setDefaultValue(options.find((o) => o[optionValueKey] === value[optionValueKey] || o[optionValueKey] === value));
    }
  }, [value, options]);

  useEffect(() => {
    if (typeof error === "boolean") {
      setErrorAutoComplete(error);
    }
  }, [error]);

  /** handlers */

  const handlerChange = (e, v) => {
    setDefaultValue(v);
    if (onChange) {
      onChange(v);
    }
  };

  const defaultInput = (params) => {
    if (icon) {
      params.InputProps.startAdornment = (
        <>
          <InputAdornment position="start">{icon}</InputAdornment>
          {params.InputProps.startAdornment}
        </>
      );
    }
    return (
      <TextField
        id={`render-input-${id}`}
        role={roles.input}
        aria-label={props.label}
        label={props.label}
        required={props.required}
        error={errorAutoComplete}
        variant="outlined"
        {...params}
        {...props}
        placeholder={defaultValue?.length ? "" : props.placeholder}
      />
    );
  };

  const getOptSel = (option, value) => {
    return option[optionValueKey] === value?.[optionValueKey] || option[optionValueKey] === value;
  };

  return (
    <Autocomplete
      id={id}
      role={roles.autoComplete}
      aria-label={props.label}
      getOptionLabel={getOptionLabel ? getOptionLabel : (option) => option[optionLabelKey] || ""}
      isOptionEqualToValue={isOptionEqualToValue ? isOptionEqualToValue : getOptSel}
      renderInput={defaultInput}
      renderOption={renderOption}
      noOptionsText="Pas de résultat"
      options={options || []}
      value={defaultValue || null}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      onChange={handlerChange}
      renderValue={renderTags}
      limitTags={limitTags}
      filterOptions={filterOptions}
      disabled={disabled}
      disableClearable={disableClearable}
      {...props}
      {...style}
    />
  );
};
